import React, { useState } from "react";
import Header from "../component/layout/header";
import PageHeader from "../component/layout/pageheader";
import FooterSection from "../component/layout/footer";
import GoogleMap from "../component/section/googlemap";
import phone from "phone";
import axios from "axios";
import { config } from "../config";
import { toast } from "react-toastify";
import Loader from "../component/section/loader";
import Notify from "simple-notify";

const titel = "Don't Be A Stranger. Say Hello.";
const desc =
  "Let us know what you need and we will be glad to provide guidance.";
const btnText = "Send Message";
const infotitle = "Get Information";
const infodesc =
  "Our Contact information Details and Follow us on social media";

let ContactInfoList = [
  {
    imgUrl: "assets/images/contact/01.png",
    imgAlt: "contact info thumb",
    infoTitle: "Address",
    infoDesc: "Ihesiaba Court, Ishaya Shekari Crescent, Federal Staff Housing Estate, Gwarinpa, Abuja, FCT Nigeria",
  },
  {
    imgUrl: "assets/images/contact/03.png",
    imgAlt: "contact info thumb",
    infoTitle: "Send Mail",
    infoDesc: "hello@tegalapp.com",
  },
  {
    imgUrl: "assets/images/contact/04.png",
    imgAlt: "contact info thumb",
    infoTitle: "Our Website",
    infoDesc: "www.tegalapp.com",
  },
];

function ContactPage() {
  const [isLoading, setLoader] = useState(false);
  const [input, setInput] = useState({
    name: "",
    phoneNumber: "",
    emailAddress: "",
    subject: "",
    message: "",
  });

  const submit = () => {
    if (
      input.name !== "" &&
      input.emailAddress !== "" &&
      input.phoneNumber !== "" &&
      input.subject !== "" &&
      input.message !== ""
    ) {
      if (phone(input.phoneNumber, { country: "NG" }).isValid) {
        setLoader(true);
        axios
          .post(config.baseURL + "/api/v1/message/public", input)
          .then(function (response) {
            setLoader(false);
            if (response.data.success) {
              setInput({
                name: "",
                phoneNumber: "",
                emailAddress: "",
                subject: "",
                message: "",
              });
              new Notify({
                title: "Request Successul",
                text: "Your message has been sent",
                status: "success",
                showCloseButton: true,
                autoclose: false,
              });
              setTimeout(() => {
                window.location.href = "/";
              }, 3000);
            } else {
              setLoader(false);
              toast.warn(response.data.message);
            }
          })
          .catch(function (error) {
            setLoader(false);
            toast.error("Unable to send message");
          });
      } else {
        toast.error("Invalid phone number");
      }
    } else {
      toast.warning("All fields required");
    }
  };

  return (
    <div>
      <Header />
      <PageHeader title={"Contact Us"} />
      <div className="contact-section">
        <div className="contact-top padding-tb aside-bg padding-b">
          <div className="container">
            <div className="row">
              <div className="col-lg-8">
                <article className="contact-form-wrapper">
                  <div className="contact-form">
                    <h4>{titel}</h4>
                    <p className="mb-5">{desc}</p>
                    <form
                      action="#"
                      method="POST"
                      id="commentform"
                      className="comment-form"
                    >
                      <input
                        type="text"
                        name="name"
                        id="item01"
                        value={input.name}
                        onChange={(e) => {
                          setInput({ ...input, name: e.target.value });
                        }}
                        placeholder="Your Name *"
                      />
                      <input
                        type="text"
                        name="email"
                        id="item02"
                        value={input.emailAddress}
                        onChange={(e) => {
                          setInput({ ...input, emailAddress: e.target.value });
                        }}
                        placeholder="Your Email *"
                      />
                      <input
                        type="text"
                        name="subject"
                        id="item03"
                        value={input.subject}
                        onChange={(e) => {
                          setInput({ ...input, subject: e.target.value });
                        }}
                        placeholder="Your Subject *"
                      />
                      <input
                        type="text"
                        name="number"
                        id="item04"
                        value={input.phoneNumber}
                        onChange={(e) => {
                          setInput({ ...input, phoneNumber: e.target.value });
                        }}
                        placeholder="Mobile Number *"
                      />
                      <textarea
                        rows="8"
                        type="text"
                        id="item05"
                        name="message"
                        value={input.message}
                        onChange={(e) => {
                          setInput({ ...input, message: e.target.value });
                        }}
                        placeholder="Your Message"
                      ></textarea>
                      <button
                        type="button"
                        className="lab-btn"
                        onClick={!isLoading ? submit : {}}
                      >
                        {isLoading ? <Loader /> : <span>{btnText}</span>}
                      </button>
                    </form>
                  </div>
                </article>
              </div>
              <div className="col-lg-4">
                <div className="contact-info-wrapper">
                  <div className="contact-info-title">
                    <h5>{infotitle}</h5>
                    <p>{infodesc}</p>
                  </div>
                  <div className="contact-info-content">
                    {ContactInfoList.map((val, i) => (
                      <div className="contact-info-item" key={i}>
                        <div className="contact-info-inner">
                          <div className="contact-info-thumb">
                            <img src={`${val.imgUrl}`} alt={`${val.imgAlt}`} />
                          </div>
                          <div className="contact-info-details">
                            <span className="fw-bold">{val.infoTitle}</span>
                            <p>{val.infoDesc}</p>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <GoogleMap />
      </div>
      <FooterSection />
    </div>
  );
}

export default ContactPage;
